/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedContactDealerButton_item$ref = any;
type PdpSharedContactSupportButton_item$ref = any;
type PdpSharedMakeOfferButton_item$ref = any;
type PdpSharedRequestHold_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSidebarContact_item$ref: FragmentReference;
export type PdpRespSidebarContact_item = {|
  +isCustomizable: ?boolean,
  +$fragmentRefs: PdpSharedRequestHold_item$ref & PdpSharedContactDealerButton_item$ref & PdpSharedMakeOfferButton_item$ref & PdpSharedContactSupportButton_item$ref,
  +$refType: PdpRespSidebarContact_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSidebarContact_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isCustomizable",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedRequestHold_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSupportButton_item",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c6398452781e034901c582a7725f2e9b';
module.exports = node;
